import { render, staticRenderFns } from "./zhongShanQuestionnaire.vue?vue&type=template&id=501f95e2&scoped=true"
import script from "./zhongShanQuestionnaire.vue?vue&type=script&lang=js"
export * from "./zhongShanQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./zhongShanQuestionnaire.vue?vue&type=style&index=0&id=501f95e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f95e2",
  null
  
)

export default component.exports